var map = {
	"./home-entertainment.de-CH.json": 1365,
	"./home-entertainment.de-DE.json": 1366,
	"./home-entertainment.en-CA.json": 1367,
	"./home-entertainment.en-GB.json": 1368,
	"./home-entertainment.en-IN.json": 1369,
	"./home-entertainment.en-ME.json": 1370,
	"./home-entertainment.en-US.json": 1371,
	"./home-entertainment.es-EM.json": 1372,
	"./home-entertainment.es-ES.json": 1373,
	"./home-entertainment.fr-BE.json": 1374,
	"./home-entertainment.fr-CA.json": 1375,
	"./home-entertainment.fr-CH.json": 1376,
	"./home-entertainment.nl-BE.json": 1377,
	"./home-entertainment.nl-NL.json": 1378,
	"./home-entertainment.pl-PL.json": 1379,
	"./home-entertainment.pt-BR.json": 1380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1364;